import { francePAEs } from "./francePAEs";

const documents = {
  acknowledge_document: `Confirmar {{documentClass}}`,
  acknowledge_document_subtitle: `Añade una nota antes de aceptar o rechazar este {{documentClass}}`,
  note: `Nota`,
  note_max_length: `La nota no puede superar los 500 caracteres`,
  agree: `Aceptar`,
  disagree: `Rechazar`,
  document_acknowledged_successfully: `Documento confirmado correctamente`,
  agreed: `Aceptado`,
  disagreed: `Rechazado`,
  acknowledgment_details: `Detalles de confirmación`,
  acknowledged_by: `Confirmado por`,
  acknowledged_on: `Confirmado el`,
  upload_via_qr_code: `Subir mediante código QR`,
  scan_this_qr_code_to_download_dost_app: `Escanea este código QR para descargar la aplicación Dost (Android)`,
  scan_the_qr_code_to_instantly_upload_your_documents_with_the_dost_app: `Escanea el código QR para subir tus documentos al instante con la aplicación Dost`,
  click_the_button_below_to_download: `Haz clic en el botón de abajo para descargar la aplicación`,
  dont_have_the_dost_app: "¿No tienes la aplicación Dost?",
  or: "O",
  no_: "No.",
  document_date: "Fecha del documento",
  vendor_address: "Dirección del proveedor",
  code: "Código",
  description: "Descripción",
  purchase_order: "Orden de compra",
  delivery_note: "Nota de entrega",
  quantity: "Cantidad",
  unit_price: "Precio unitario",
  discount: "Descuento",
  amount: "Monto",
  vat: "IVA",
  subtotal: "Subtotal",
  total_without_tax: "Total (sin impuestos)",
  total_tax: "Total de impuestos",
  total: "Total",
  use_the_dost_upload_app_to_scan_documents_and_send_them_directly_to_your_portal: `Utilice la aplicación Dost Upload para escanear documentos y enviarlos directamente a su portal.`,
  steps_to_scan_qr: `Pasos para escanear el código QR`,
  open_dost_upload_app_on_your_phone: `Abra la aplicación Dost Upload en su teléfono`,
  select_the_camera_option: `Seleccione la opción de cámara`,
  take_a_photo_and_edit_if_necessary: `Tome una foto y edítela si es necesario`,
  scan_this_qr_code_to_send_to_dost_portal: `Escanee este código QR para enviarlo al portal de Dost`,
  dont_have_the_dost_upload_app: `¿No tiene la aplicación Dost Upload?`,
  scan_this_qr_code_to_download_the_app: `Escanee este código QR para descargar la aplicación.`,
  download_dost_upload_app_android: `Descargar la aplicación Dost Upload (Android)`,
  upload_documents_from_device: `Subir documentos desde el dispositivo`,
  drag_and_drop_your_files_or_click_to_browse: `Arrastra y suelta tus archivos o haz clic para buscarlos`,
  no_document_uploaded: `No se ha subido ningún documento`,
  duplicate_files_are_not_allowed: `Se detectaron documentos duplicados`,
  files_cannot_be_more_than_10: `No se pueden subir más de 10 archivos`,
  document_uploaded_successfully: `Documento subido correctamente`,
  document_upload_unsuccessful: `Error al subir el documento`,
  receive_via_invitation_subtitle: `Invita a tu {{entity}} al Portal Dost {{portalName}}, donde podrán iniciar sesión y cargar documentos directamente.`,
  send_invites: `Enviar invitaciones`,
  receive_via_customers_portal: `Recibir a través del portal del cliente`,
  customers_uploads_directly_in_customers_portal: `El cliente carga los documentos directamente en el portal del cliente`,
  receive_via_suppliers_portal: `Recibir a través del Portal de Proveedores`,
  suppliers_uploads_directly_in_suppliers_portal: `El proveedor carga los documentos directamente en el Portal de Proveedores`,
  pay_invoices: `Pagar facturas`,
  export: `Exportar`,
  statusCode: "Código de estado",
  statusName: "Nombre del estado",
  rejectionReason: "Motivo del rechazo",
  direction: "Dirección",
  sendStatus: "Enviar estado",
  "E-Invoice Status": "Estado de la factura electrónica",
  apply: "Aplicar",
  document_upload_via_qr: `Carga de documentos vía QR`,
  ...francePAEs,
};

export default documents;
